/* app/js/src/components/channel/channels-dashboard/channels-dashboard.component.scss */
.cursor-pointer {
  cursor: pointer;
}
main::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
main::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
main::-webkit-scrollbar-corner {
  background: transparent;
}
main::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
main::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
main::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
main::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
main::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
:host {
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #eef2f6;
  overflow-y: hidden;
}
:host a {
  text-decoration: none;
}
.download-recording {
  white-space: nowrap;
}
.channel-clock {
  color: #879baf;
  font-family: "Open Sans";
  font-size: 12px;
  padding-left: 5px;
  position: absolute;
  top: 0;
  font-weight: bold;
}
.main-header {
  padding: 4px 0 4px 60px;
  background-color: white;
  height: 40px;
  flex-grow: 0;
  flex-shrink: 0;
}
.main-header .mychannel-header-container {
  display: inline;
  line-height: 32px;
}
.main-header label {
  font-size: 12px;
  font-weight: bold;
  color: #232f3a;
}
.main-header button {
  background-color: transparent;
  outline: none;
  border: none;
  margin-right: 10px;
}
.main-header button ::ng-deep svg path {
  fill: #93a9bf !important;
}
main {
  overflow-y: auto;
  padding-top: 60px;
  padding-left: calc((100% - 905px) / 2);
  padding-right: calc((100% - 905px) / 2);
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: flex-start;
  justify-content: flex-start;
  -webkit-flex-basis: 100%;
  -ms-flex-basis: 100%;
  flex-basis: 100%;
}
main > a {
  width: 260px;
  height: 195px;
  margin-right: 38px;
}
main .new-channel {
  width: 260px;
  height: 195px;
  background-color: #ffffff;
  margin: 0 38px 38px 0;
  position: relative;
  cursor: pointer;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
}
main .new-channel div {
  width: 91%;
  height: 89%;
  border: 1px dashed #c6d2df;
  position: absolute;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  opacity: 0;
}
main .new-channel svg {
  fill: #40c4ff;
  -ms-transform: translateY(1em);
  -webkit-transform: translateY(1em);
  transform: translateY(1em);
}
main .new-channel svg path {
  -ms-transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  transform-origin: center center;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
}
main .new-channel span {
  margin-top: 1em;
  font-size: 0.9em;
  display: block;
  color: #c6d2df;
  text-decoration: none;
  border: none;
  pointer-events: none;
  opacity: 0;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -ms-transform: translateY(1.5em);
  -webkit-transform: translateY(1.5em);
  transform: translateY(1.5em);
}
main .new-channel:hover div {
  opacity: 1;
}
main .new-channel:hover svg {
  -ms-transform: translateY(1em);
  -webkit-transform: translateY(1em);
  transform: translateY(1em);
  fill: #c6d2df;
}
main .new-channel:hover svg path {
  -ms-transform: rotate(270deg);
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg);
}
main .new-channel:hover span {
  opacity: 1;
  -ms-transform: translateY(1em);
  -webkit-transform: translateY(1em);
  transform: translateY(1em);
}
main .channel {
  width: 260px;
  height: 195px;
  background-color: #ffffff;
  margin: 0 38px 38px 0;
  position: relative;
}
main .channel:hover .hover-layer {
  z-index: 1;
  opacity: 1;
}
main .channel .hover-layer {
  width: 260px;
  height: 146.3px;
  position: absolute;
  opacity: 0;
  background-color: rgba(35, 47, 58, 0.8);
  cursor: pointer;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
main .channel .hover-layer .channel-menu-icon {
  position: absolute;
  right: 0;
  cursor: pointer;
  width: 50px;
  height: 30px;
}
main .channel .hover-layer .channel-menu-icon:hover ::ng-deep svg path {
  fill: #ffffff !important;
}
main .channel .hover-layer .buttons {
  height: 25px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  gap: 1px;
  justify-content: space-around;
  margin: auto;
}
main .channel .hover-layer .buttons > a > button {
  width: 65px;
}
main .channel .hover-layer div {
  display: flex;
  justify-content: space-around;
}
main .channel .hover-layer div a {
  position: relative;
}
main .channel .hover-layer div a button {
  background-color: transparent;
  outline: none;
  border: none;
}
main .channel .hover-layer div a button ::ng-deep svg {
  width: 20px;
  height: 20px;
}
main .channel .hover-layer div a button ::ng-deep svg path {
  fill: #93a9bf !important;
}
main .channel .hover-layer div a button ::ng-deep svg g polygon {
  fill: #93a9bf !important;
}
main .channel .hover-layer div a button:hover ::ng-deep svg path {
  fill: #ffffff !important;
}
main .channel .hover-layer div a button:hover ::ng-deep svg g polygon {
  fill: #ffffff !important;
}
main .channel .hover-layer div a button:hover::after {
  color: #ffffff;
}
main .channel .hover-layer div a button::after {
  color: transparent;
  content: attr(data-name);
  font-size: 0.7em;
  position: relative;
  display: block;
  top: 8px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -ms-transform: translateY(15px);
  -webkit-transform: translateY(15px);
  transform: translateY(15px);
}
main .channel .channel-box {
  width: 260px;
  height: 146.3px;
  background-color: #232f3a;
  background-size: 100% 100%;
}
main .channel .channel-box button {
  padding-bottom: 22px;
  position: absolute;
  top: 120px;
  background-color: black;
  outline: none;
  border: none;
  float: left;
  height: 20px;
  width: 22px;
  z-index: 5;
  padding-left: 5px;
  margin-left: 3px;
}
main .channel .channel-box button ::ng-deep svg {
  height: 20px;
  width: 15px;
}
main .channel .channel-box button ::ng-deep svg path {
  fill: #ffffff !important;
}
main .channel .channel-info {
  width: 260px;
  height: 48.8px;
  font-size: 10px;
  display: flex;
  padding: 0 11px;
  flex-direction: row;
  justify-content: flex-start;
  position: relative;
  background-color: white;
}
main .channel .channel-info .date-name-container {
  display: flex;
  flex-direction: column;
  padding-top: 9px;
  margin-left: 25px;
}
main .channel .channel-info .date-name-container .date {
  color: #879baf;
}
main .channel .channel-info .led-box {
  position: absolute;
  top: 15px;
}
main .channel .channel-info .led-box .indicator {
  width: 18px;
  height: 18px;
  box-shadow: 0 1px 3px 0 rgba(35, 47, 58, 0.17);
  border: solid 1px #c6d2df;
  border-radius: 50%;
  padding-top: 3px;
  padding-left: 3px;
}
main .channel .channel-info .led-box .indicator .led-blue {
  width: 10px;
  height: 10px;
  background-color: #c6d2df;
  border-radius: 50%;
}
main .channel .channel-info .led-box .indicator .led-red {
  width: 10px;
  height: 10px;
  background-color: #ef5350;
  border-radius: 50%;
}
main .channel .channel-info .full-screen-button {
  position: absolute;
  top: 11px;
  left: 225px;
  width: 18px;
  height: 18px;
  background-color: #f1f3f4;
  border: solid 1px #e1e6eb;
  border-radius: 4px;
  cursor: pointer;
  padding-left: 2px;
  padding-top: 2px;
}
main .channel .channel-info .full-screen-button .full-screen-svg ::ng-deep svg {
  fill: #4d5761;
  font-weight: bold;
}
@media only screen and (max-width : 1300px) {
  main .channel {
    width: 250px;
  }
}
.channel-menu {
  width: 155px;
  background-color: #ffffff;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px #e1e6eb;
  border-radius: 4px;
  padding: 21px 21px 11px 21px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  font-size: 12px;
  color: #879baf;
  text-align: left;
}
.channel-menu div {
  margin-bottom: 10px;
}
.channel-menu div:hover {
  color: #232f3a;
}
.popover-confirmation {
  width: 276px;
  padding: 1px;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  z-index: 1;
  position: absolute;
  margin-top: 10px;
}
.popover-confirmation h3 {
  padding: 8px 14px;
  margin: 0;
  font-size: 14px;
  border-bottom: 1px solid #e9ebee;
  border-radius: 5px 5px 0 0;
}
.popover-confirmation .content {
  padding: 9px 14px;
}
.popover-confirmation .content p {
  margin: 0 0 10px;
}
.popover-confirmation .content .buttons {
  margin-right: -15px;
  margin-left: -15px;
  display: flex;
}
.popover-confirmation .content .buttons .button {
  flex-grow: 1;
  text-align: center;
  margin-right: 15px;
  margin-left: 15px;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
}
.popover-confirmation .content .buttons .button.yes {
  color: #ffffff;
  background-color: #232f3a;
  border: 1px solid #e3e6ea;
}
.popover-confirmation .content .buttons .button.yes:hover {
  background-color: #ffffff;
  color: #232f3a;
}
.popover-confirmation .content .buttons .button.no {
  background-color: #ffffff;
  border: 1px solid #e3e6ea;
}
.popover-confirmation .content .buttons .button.no:hover {
  background-color: #eef2f6;
}
.choose-channel-server-policy-container {
  float: right;
}
.choose-channel-server-policy-container label {
  font-family: "Open Sans";
  font-size: 12px;
  color: #7d8fa1;
  font-weight: normal;
}
.choose-channel-server-policy-container icn-dropdown-item {
  font-size: 10px;
}
video::-webkit-media-controls-enclosure {
  display: none !important;
}
.custom-video-controls {
  z-index: 2147483648 !important;
  height: 40px;
  background-color: #eef2f6;
  display: flex;
  flex-direction: column;
  padding: 10px;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  pointer-events: auto;
}
.quality-settings-fullscreen {
  z-index: 9999999999;
  height: 150px;
  width: 100px;
  background-color: black;
  padding: 15px;
  bottom: 40px;
  right: 0px;
  margin: 0 10px 10px 0;
  position: absolute;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.quality-settings-fullscreen:hover {
  cursor: pointer;
}
.single-quality-container {
  display: flex;
  justify-content: flex-start;
}
.success {
  line-height: 31px;
  width: 18px;
  height: 18px;
}
.success ::ng-deep svg {
  width: 18px;
  height: 18px;
}
.success ::ng-deep svg path {
  fill: white !important;
}
.controls {
  display: flex;
  justify-content: space-between;
}
.controls-left {
  display: flex;
}
.controls-right {
  display: flex;
}
.play {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.play:hover {
  cursor: pointer;
}
.play:hover ::ng-deep svg g g {
  fill: #93a9bf !important;
}
.play ::ng-deep svg {
  width: 20px;
  height: 20px;
}
.sound {
  margin-top: 1px;
  margin-right: 10px;
  margin-left: 2.5px;
  width: 16px;
  height: 16px;
}
.sound:hover {
  cursor: pointer;
}
.sound:hover ::ng-deep svg path {
  fill: #93a9bf !important;
}
.sound ::ng-deep svg {
  width: 16px;
  height: 16px;
}
.sound ::ng-deep svg path {
  fill: #232f3a !important;
}
.muted {
  margin-right: 10px;
  width: 18px;
  height: 18px;
}
.muted:hover {
  cursor: pointer;
}
.muted:hover ::ng-deep svg path {
  fill: #93a9bf !important;
}
.muted ::ng-deep svg {
  width: 18px;
  height: 18px;
}
.muted ::ng-deep svg path {
  fill: #232f3a !important;
}
.settings {
  width: 20px;
  height: 20px;
}
.settings:hover {
  cursor: pointer;
}
.settings:hover ::ng-deep svg g g {
  fill: #93a9bf !important;
}
.settings ::ng-deep svg {
  width: 20px;
  height: 20px;
}
.settings ::ng-deep svg g g {
  fill: #232f3a !important;
}
.fullscreen {
  margin-left: 10px;
  width: 18px;
  height: 18px;
}
.fullscreen:hover {
  cursor: pointer;
}
.fullscreen:hover ::ng-deep svg path {
  fill: #93a9bf !important;
}
.fullscreen ::ng-deep svg {
  width: 18px;
  height: 18px;
}
.fullscreen ::ng-deep svg path {
  fill: #232f3a !important;
}
.quality {
  font-family: "Open Sans";
  font-size: 12px;
  color: white;
  margin-left: 3px;
}
.fullscreen-container {
  width: 100%;
  height: 146px;
}
/*# sourceMappingURL=channels-dashboard.component.css.map */
